import { render, staticRenderFns } from "./Notary.vue?vue&type=template&id=3244f345&"
import script from "./Notary.vue?vue&type=script&lang=js&"
export * from "./Notary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports